export const getActivePageId = page => {
  if (!page || !page.nodes || !page.nodes[0]) return null

  return page.nodes[0].id || null
}

export const getMenuItems = menu => {
  if (!menu || !menu.menuItems) return []

  return menu.menuItems.nodes || []
}

export const getPageMenuItemsTrail = (pageId, menuItems) => {
  const tupplePageMenusIds = menuItems.reduce((acc, it) => {
    if (it.connectedNode && it.connectedNode.node)
      acc[it.connectedNode.node.id] = it.id
    return acc
  }, {})

  let trail = []
  let currentMenuItemId = tupplePageMenusIds[pageId]
  let currentMenuItem = null
  while (currentMenuItemId) {
    // eslint-disable-next-line
    currentMenuItem = menuItems.filter(it => it.id === currentMenuItemId)[0]
    trail.unshift(currentMenuItem)
    currentMenuItemId = currentMenuItem.parentId
  }

  return trail
}

const _getPageMenuItemsTrail = (page, menu) => {
  const menuItems = getMenuItems(menu)
  const pageId = getActivePageId(page)

  return getPageMenuItemsTrail(pageId, menuItems)
}

export const getPageRootMenuItemId = (page, menu) => {
  const menuTrail = _getPageMenuItemsTrail(page, menu)

  if (!menuTrail || !menuTrail.length) return null

  return menuTrail[0].id || null
}

export const getMidLevelMenuItemId = (page, menu) => {
  const menuTrail = _getPageMenuItemsTrail(page, menu)

  if (!menuTrail || menuTrail.length < 3) return null

  return menuTrail[1].id || null
}

export const getPageMenuItemId = (page, menu) => {
  const menuTrail = _getPageMenuItemsTrail(page, menu)

  if (!menuTrail || !menuTrail.length) return null

  return menuTrail[menuTrail.length - 1].id || null
}

export const getExcerpt = menu => {
  if (!menu || !menu.connectedNode || !menu.connectedNode.node) return null

  return menu.connectedNode.node.excerpt || null
}

export const getChildMenuItems = (menuItems, extendedMenuItem) => {
  if (!extendedMenuItem || !extendedMenuItem.id) return []

  const firstLevelMenuItems = menuItems.filter(
    menuItem => menuItem.parentId === extendedMenuItem.id
  )
  const firstLevelMenuItemsIds = firstLevelMenuItems.map(
    menuItem => menuItem.id
  )

  const secondLevelMenuItems = menuItems.filter(menuItem =>
    firstLevelMenuItemsIds.includes(menuItem.parentId)
  )

  return [...firstLevelMenuItems, ...secondLevelMenuItems]
}

export const getSupportedLanguages = languages => {
  if (!languages || !languages.edges) return []

  const edge = languages.edges[0]
  if (!edge || !edge.node || !edge.node.languages) return []

  return edge.node.languages || []
}

export const getConnectedPageBranding = menuItem => {
  let branding = `cubewise-branding`

  if (!menuItem || !menuItem.connectedNode || !menuItem.connectedNode.node)
    return branding

  const connectedPage = menuItem.connectedNode.node
  if (
    !connectedPage.categories ||
    !connectedPage.categories.nodes ||
    !connectedPage.categories.nodes.length
  )
    return branding

  const category = connectedPage.categories.nodes[0]
  if (!category.slug) return branding

  switch (category.slug) {
    case `technical`:
      branding = `code-branding`
      break
    case `education`:
      branding = `education-branding`
      break
    case `support`:
      branding = `support-branding`
      break
  }

  return branding
}
